module.exports = __webpack_public_path__ + "static/media/instantgaming.6091769d.svg";